import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { ArrowIcon } from "../icons";
import { artistDates } from "./shared";
import { artistShape } from "../shapes";

const Item = ({ artist, index, itemProps, highlighted, selected, theme }) => (
  <button
    {...itemProps({
      item: artist,
      index,
      className: classNames({
        "m-artist-list-item": true,
        "m-artist-list-item--is-active": highlighted,
        "m-artist-list-item--is-selected": selected,
        "m-artist-list-item--selectable": artist.show_bio || theme === "subnav",
      }),
      // All artists should be enabled if the list is in the subnav
      disabled: !artist.show_bio && theme !== "subnav",
    })}
  >
    <span>
      <span className="m-artist-list-item__name">{artist.name} </span>
      <span className="m-artist-list-item__dates">{artistDates(artist)}</span>
    </span>
    <ArrowIcon className="m-artist-list-item__arrow-icon" />
  </button>
);

Item.displayName = "ArtistComboBox.Item";

Item.propTypes = {
  artist: PropTypes.shape(artistShape).isRequired,
  index: PropTypes.number.isRequired,
  itemProps: PropTypes.func.isRequired,
  highlighted: PropTypes.bool,
  selected: PropTypes.bool,
  theme: PropTypes.oneOf(["default", "subnav"]),
};

export default Item;
